import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

// :white_check_mark: Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyAoG40DvcCVur2B5v1Se49dIij5wdP9Vgw",
  authDomain: "broker-white-label-78049.firebaseapp.com",
  projectId: "broker-white-label-78049",
  storageBucket: "broker-white-label-78049.firebasestorage.app",
  messagingSenderId: "491813108560",
  appId: "1:491813108560:web:014d802240ede326298a55",
  measurementId: "G-GQW48YC54L",
};

// :white_check_mark: Initialize Firebase
const app = initializeApp(firebaseConfig);

let messaging = null;

// :white_check_mark: Safe Messaging Setup
isSupported()
  .then((supported) => {
    if (!supported) {
      console.warn(
        ":warning: Firebase Messaging not supported in this browser."
      );
      return;
    }

    messaging = getMessaging(app);
    console.log(":white_check_mark: Firebase Messaging initialized.");

    // Ask for permission safely
    if ("Notification" in window && navigator.serviceWorker) {
      Notification.requestPermission()
        .then((permission) => {
          if (permission === "granted") {
            console.log(":bell: Notifications permission granted.");
            updateFCMToken();
          } else {
            console.warn(":lock: Notifications permission denied.");
          }
        })
        .catch((err) => {
          console.error(":x: Error requesting notification permission:", err);
        });
    } else {
      console.warn(":warning: Notifications not supported in this browser.");
    }

    // Foreground messages
    onMessage(messaging, (payload) => {
      console.log(":envelope_with_arrow: Foreground push received:", payload);
      handleIncomingFCM(payload);
    });

    // Refresh token every 10 mins
    setInterval(() => {
      updateFCMToken();
    }, 10 * 60 * 1000);
  })
  .catch((err) => {
    console.error(":x: Error checking FCM support:", err);
  });

// :white_check_mark: Function to Get & Save Token
export const updateFCMToken = async () => {
  if (!messaging) {
    console.warn(":warning: Messaging not initialized or supported.");
    return;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BNEjwAWQfLZ_bzwr9IDOrZMGEh-MU6hqaEMBLOZVNj2juJ3eE8v56TpEb5Yd61tksuqFAoj0pP_87Ub9TclnSy0",
    });

    if (currentToken) {
      console.log(":key: Current FCM Token:", currentToken);

      const savedToken = localStorage.getItem("fcmToken");
      if (savedToken !== currentToken) {
        localStorage.setItem("fcmToken", currentToken);

        // TODO: Send token to backend
        // await fetch('/api/save-token', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ token: currentToken }),
        // });
      } else {
        console.log(":heavy_check_mark: Token unchanged.");
      }
    } else {
      console.warn(
        ":warning: No FCM token available (permission may be denied)."
      );
    }
  } catch (err) {
    console.error(":x: Error getting token:", err);
  }
};

// :white_check_mark: Foreground Push Handler
const handleIncomingFCM = (payload) => {
  console.log(":fire: Incoming push:", payload);

  // Dispatch a custom event so app can listen
  const event = new CustomEvent("fcm-notification", { detail: payload });
  window.dispatchEvent(event);

  // Optional: show a notification if allowed
  if ("Notification" in window && Notification.permission === "granted") {
    try {
      new Notification(payload.notification?.title || "New Message", {
        body: payload.notification?.body || "You have a new notification",
        icon: payload.notification?.icon || "/firebase-logo.png",
      });
    } catch (err) {
      console.warn(":warning: Could not display notification:", err);
    }
  }
};
